import { actions as actionsCellphoneRecharge } from 'features/CellphoneRecharge'

const LIMIT_SCHEDULED_ORDERS = 30

export const getScheduledOrders = date => {
  return {
    type: 'GET_SCHEDULED_ORDERS',
    payload: {
      client: 'cloudloyalty',
      request: {
        method: 'get',
        url: `/v1/myschedules/limit/${LIMIT_SCHEDULED_ORDERS}`
      }
    },
    date: date
  }
}

export const editServiceItem = item => {
  return {
    type: 'EDIT_SERVICE_ITEM',
    item: item
  }
}

export const newServiceItem = () => ({
  type: 'NEW_SERVICE_ITEM'
})

export const updateScheduleOrder = client => scheduleOrder => {
  return (dispatch, _) => {
    dispatch({ type: 'UPDATE_MOBILE_RECHARGE_SCHEDULE_ORDER' })
    client
      .put('/v3/myschedules', scheduleOrder)
      .then(response => {
        if (response.status === 200) {
          dispatch({ type: 'CLEAR_SERVICE_ITEM' })
          dispatch({ type: 'UPDATE_MOBILE_RECHARGE_SCHEDULE_ORDER_END' })
          dispatch({ type: 'GET_SCHEDULED_ORDERS_ORDERS' })
        }
      })
      .catch(error => {
        dispatch({ type: 'UPDATE_MOBILE_RECHARGE_SCHEDULE_ORDER_END' })
        var message = actionsCellphoneRecharge.handleErrorMessage(
          error.response.data
        )
        dispatch(actionsCellphoneRecharge.showErrorMessage(message))
      })
  }
}

export const cancelServiceItem = serviceItem => ({
  type: 'CANCEL_SERVICE_ITEM',
  payload: {
    client: 'cloudloyalty',
    request: {
      method: 'PUT',
      url: `/v1/myschedules/cancel-schedules`,
      data: serviceItem
    }
  }
})

export default client => ({
  getScheduledOrders,
  editServiceItem,
  newServiceItem,
  updateScheduleOrder: updateScheduleOrder(client),
  cancelServiceItem
})



// WEBPACK FOOTER //
// ./src/Participant/Scheduling/actions.js